"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.swrConfig = void 0;
/* istanbul ignore file @preserve */

const swrConfig = exports.swrConfig = {
  errorRetryCount: 3,
  errorRetryInterval: 10000,
  focusThrottleInterval: 300000,
  revalidateOnFocus: false,
  shouldRetryOnError: true,
  suspense: false,
  /* eslint-disable max-params -- library requires too many parameters */
  onErrorRetry: (error, key, config, revalidate, {
    retryCount
  }) => {
    const statusCode = error.response?.status ?? 200;
    if (statusCode >= 400 && statusCode < 500) {
      return;
    }
    const rCount = retryCount ?? 1;
    if (rCount >= (config.errorRetryCount ?? 0)) {
      return;
    }
    setTimeout(() => void revalidate({
      retryCount: rCount
    }), config.errorRetryInterval);
  }
  /* eslint-enable max-params */
};
//# sourceMappingURL=swrConfig.js.map